import { useOtherSettings } from '@namespace/cms';
import {
  useNotificationsInitialData,
  useSubscribeSocketNotifications,
  useUpdateMessagesCount
} from '../../hooks';

const NotificationCenterInitActual = () => {
  useNotificationsInitialData();
  useSubscribeSocketNotifications();
  useUpdateMessagesCount();

  return null;
};

export const NotificationCenterInit = () => {
  const { isNotificationCenterEnabled = false } = useOtherSettings();

  if (!isNotificationCenterEnabled) {
    return null;
  }

  return <NotificationCenterInitActual />;
};
